import styled, { css } from 'styled-components';
import { media } from '@/styles/Qtheme.ts';
import { TabletCalVW } from '@utils/CalVW.tsx';

export const TransactionHistorySection = styled.div<{
  theme: any;
  parentHeight?: number;
}>`
  width: ${({ parentHeight }) => (parentHeight ? '100%' : '1200px')};
  min-height: ${({ parentHeight }) => (parentHeight ? 'auto' : '600px')};
  height: ${({ parentHeight }) => (parentHeight ? `${parentHeight}px` : 'auto')};
  background: ${({ theme, parentHeight }) =>
    parentHeight ? 'transparent' : theme.itemBg};
  margin-top: ${({ parentHeight }) => (parentHeight ? '0' : '20px')};
  border-radius: ${({ parentHeight }) => (parentHeight ? '0' : '8px')};
  box-shadow: ${({ parentHeight }) =>
    parentHeight ? 'none' : '0 4px 12px rgba(0, 0, 0, 0.1)'};
  overflow: ${({ parentHeight }) => (parentHeight ? 'visible' : 'hidden')};
  padding-bottom: 60px;

  ${({ parentHeight }) =>
    parentHeight &&
    css`
      .transaction-history-table {
        .ant-table {
          background: transparent !important;
        }

        .ant-table-thead > tr > th {
          background: transparent !important;
        }

        .ant-table-tbody > tr > td {
          background: transparent !important;
        }
      }

      .ant-select-selector {
        border: none !important;
        outline: none !important;
        box-shadow: none !important;
      }
    `}

  @media ${media.desktop} {
    width: ${TabletCalVW(900)};
  }

  .ant-table-wrapper {
    .ant-table {
      .ant-table-container {
        .ant-table-body {
          overflow: auto !important;

          /* 스크롤바 커스터마이징 */
          &::-webkit-scrollbar {
            width: 8px;
            height: 8px;
          }

          &::-webkit-scrollbar-track {
            background: transparent;
          }

          &::-webkit-scrollbar-thumb {
            background: rgba(255, 255, 255, 0.3);
            border-radius: 4px;

            &:hover {
              background: rgba(255, 255, 255, 0.5);
            }
          }

          /* Firefox 스크롤바 스타일링 */
          scrollbar-width: thin;
          scrollbar-color: rgba(255, 255, 255, 0.3) transparent;
        }
      }
    }
  }
`;
